import { Chip, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { WorkInstructionUIStore } from '../../stores/work-instruction.ui-store'
import { ControlRoomAccordion } from '../molecules/ControlRoomAccordion'

interface Props {
  store: WorkInstructionUIStore
}

export const WorkInstructionHousekeepingGroups = observer(({ store }: Props) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const othersLabel = t('internalMoves.othersGroup', 'Ad-hoc moves')

  // Push the translated label into the store so the computed group list can render it
  // without coupling the store to Tolgee.
  useEffect(() => {
    store.setOthersGroupLabel(othersLabel)
  }, [store, othersLabel])

  return (
    <Stack sx={{ maxHeight: 'calc(100vh - 205px)', overflowY: 'auto' }}>
      {store.housekeepingGroups.map(group => (
        <ControlRoomAccordion
          key={`housekeeping-group-${group.id}`}
          isSelected={store.selectedHousekeepingGroupId === group.id}
          title={group.name}
          onChange={() => store.setSelectedHousekeepingGroupId(group.id)}
          hasDetails={false}
          rightSummaryRender={
            group.isOthers ? null : (
              <Chip
                size='small'
                label={t('internalMoves.progressLabel', '{completed}/{total} complete', {
                  completed: group.completedMovesCount,
                  total: group.totalMovesCount,
                })}
                color={
                  group.completedMovesCount === group.totalMovesCount && group.totalMovesCount > 0
                    ? 'success'
                    : 'default'
                }
              />
            )
          }
        >
          {null}
        </ControlRoomAccordion>
      ))}

      {store.housekeepingGroups.every(g => g.isOthers) && (
        <Typography
          padding={theme.customSpacing.m}
          paddingX={theme.customSpacing.xl}
          variant='body1'
          color='secondary'
          textAlign='center'
        >
          {t('internalMoves.noPlans', 'No housekeeping plans active')}
        </Typography>
      )}
    </Stack>
  )
})
